interface IconFeedProps {
  active?: boolean;
}
export const IconFeed = ({ active }: IconFeedProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20.25C12 20.25 3.5 15.5 3.5 9.25C3.5 6.6 5.6 4.75 8 4.75C9.7 4.75 11.2 5.7 12 7.1C12.8 5.7 14.3 4.75 16 4.75C18.4 4.75 20.5 6.6 20.5 9.25C20.5 15.5 12 20.25 12 20.25Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
